import {
  email,
  maxLength,
  minLength,
  object,
  regex,
  string,
} from 'valibot';

export const reportErrorDataSchema = object({
  description: string([minLength(1)]),
  email: string([
    email(),
  ]),
  name: string([
    regex(/^[a-zA-Z\s-]+$/),
    maxLength(100),
  ]),
});
